export default {
  metaTitle: 'Sales Order',
  pageTitle: 'Sales Order List',
  orderStatus: 'Order Status',
  payment: 'Payment',
  payStatus: 'Pay Status',
  userId: 'User ID',
  account: 'Account',
  userPhone: 'User Phone',
  addrPhone: 'Addr Phone',
  so: 'SO',
  sku: 'SKU',
  listingId: 'Listing',
  placeholder1: 'Id or serial',
  placeholder2: 'Listing Title',
  userConfirm: 'User Confirm',
  all: 'All',
  cod: 'COD',
  online: 'Online',
  pre: 'Pre',
  orderTime: 'Order Time',
  payTime: 'Payment Time',
  completedTime: 'Completed Time',
  confirmTime: 'Confirm Time',
  unpay: 'Unpay',
  paid: 'Paid',
  saleOrderStatusMap1: 'Pending Payment',
  saleOrderStatusMap2: 'Pending Confirm',
  saleOrderStatusMap3: 'Pending Dispatch',
  saleOrderStatusMap4: 'In Transit',
  saleOrderStatusMap5: 'All received',
  saleOrderStatusMap6: 'Restocking',
  saleOrderStatusMap7: 'Cancel',
  saleOrderStatusMap8: 'Rejected',
  saleOrderStatusMap9: 'Partially Received',
  saleOrderStatusMapInDelivery: 'In Delivery',
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  clientMap1: 'App',
  clientMap2: 'iOS',
  clientMap3: 'PC',
  clientMap4: 'WAP',
  confirm: '确认',
  unconfirmed: '未确认',
  soStates1: 'PendPay',
  soStates2: 'ReStock',
  soStates3: 'Confirm',
  soStates4: 'PendDisp',
  soStates5: 'InTrans',
  soStates6: 'Close',
  soStates7: 'Cancel',
  soStates8: 'Comple',
  soStates9: 'Reject',
  soStates10: 'All',
  soStates11: 'Deleted',
  closed: 'Closed',
  completed: 'Completed',
  yesterday: 'Yesterday',
  yes: 'Yes.', // 注 yes为Yesterday简写
  today: 'Today',
  tod: 'Tod.', // 注 tod为Today简写
  within_7_days: 'Within 7 days',
  w7D: '7D', // 注：7D 意为Within 7 days的简写
  within_30_days: 'Within 30 days',
  w30D: '30D', // 注：30D 意为Within 30 days的简写
  within_3_months: 'Within 3 months',
  w3M: '3M', // 注：3M 意为Within 3 months的简写
  within_1_year: 'Within 1 year',
  w1Y: '1Y', // 注：1Y 意为Within 1 year的简写
  storeClassName1: '手机',
  storeClassName2: '手机配件',
  storeClassName3: '未分类',
  columns1: 'SO Serial',
  columns2: 'SO#',
  columns3: 'Payment',
  columns4: 'Client',
  columns5: 'Type',
  orderType1: 'Normal',
  orderType2: 'Flash',
  orderType3: 'Lucky Draw',
  orderType4: 'Redeem',
  orderType5: 'Mixed',
  columns6: 'User ID',
  columns7: 'Country',
  columns8: 'City',
  columns9: 'Pay Amount',
  columns10: 'Status',
  store: 'Store',
  contactPhone: 'Contact Phone',
  filename: 'filename',
  logisticsType: 'Logistics Type',
  dsCapitalMsg: 'Sorry, you are currently unable to dispatch because you have not yet activated your platform logistics account. Click here to learn how to activate it.'
}
